module.exports = __webpack_public_path__ + "static/media/nuwan.3c575e01.png";